import React, { useEffect, useState, useRef } from 'react'
import "./navbar.css"
import { SiWebmoney } from "react-icons/si";
import { menu } from "../../data"
import { Link, animateScroll as scroll } from 'react-scroll'
import { FaArrowUpRightFromSquare, FaBarsStaggered, FaXmark } from "react-icons/fa6"
import gsap from 'gsap'
import { useGSAP } from '@gsap/react'

const Navbar = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [visible, setVisible] = useState(false);
  const container = useRef(null);

  const handleScroll = () => {
    const currentScrollPros = window.scrollY;
    if (currentScrollPros > 145) {
      return setVisible(true)
    }
    return setVisible(false)
  }

  const handleScrollTop = () => {
    scroll.scrollToTop({ duration: 500, smooth: true });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  gsap.registerPlugin(useGSAP)
  useEffect(() => {
    if (visible) {
      gsap.fromTo(".navbar__container", {
        y: -250,
        width: '100%',
      },
        {
          y: 0,
          top: 0,
          zIndex: 100,
        }
      )
    }
  }, [visible])

  useGSAP(() => {
    const timeline = gsap.timeline();
    timeline.from('.tab__item', { opacity: 0, stagger: .5 })
  }, { scope: container })

  return (
    <nav className={`navbar__container ${visible ? 'visible' : ''}`} ref={container}>
      {showSidebar ? (
        <div className='overlay' onClick={() => setShowSidebar(false)} />
      ) : null}

      <div
        className='logo__container'
        onClick={handleScrollTop}
        role="button"
        aria-label="Scroll to top"
      >
        <SiWebmoney />
      </div>

      <div className={`tab__group ${showSidebar ? 'show' : ''}`}>
        <span
          className="icon__container close__btn"
          onClick={() => setShowSidebar(false)}
          role="button"
          aria-label="Close menu"
        >
          <FaXmark />
        </span>

        {menu.map((list, index) => (
          <Link
            key={index}
            activeClass='active'
            className='tab__item name'
            to={list.name.toLowerCase()}
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            onClick={() => setShowSidebar(false)}
          >
            {list.name}
          </Link>
        ))}
      </div>

      <div className='nav__buttons__group'>
        <a
          href="https://github.com/HEYSHEED"
          className="btn btn_primary"
          target="_blank"
          rel="noreferrer"
        >
          GitHub <FaArrowUpRightFromSquare />
        </a>
        <FaBarsStaggered
          className='menu'
          onClick={() => setShowSidebar(true)}
          role="button"
          aria-label="Open menu"
        />
      </div>
    </nav>
  )
}

export default Navbar
